import { render, staticRenderFns } from "./AnswerTemplate.vue?vue&type=template&id=a92f9e3a&scoped=true"
import script from "./AnswerTemplate.vue?vue&type=script&lang=js"
export * from "./AnswerTemplate.vue?vue&type=script&lang=js"
import style0 from "./AnswerTemplate.vue?vue&type=style&index=0&id=a92f9e3a&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a92f9e3a",
  null
  
)

export default component.exports